
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as indexIJd1xfpZJ02kpMhTs2robNXOD6eukMx8P2L2L2HiBrwMeta } from "/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@3/pages/index.vue?macro=true";
import { default as _91slug_93ZOb89EzTqCvLAh12AWK11q3VFHaCD24NRaPKtYp7hucMeta } from "/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@3/pages/[slug].vue?macro=true";
import { default as indexVOF_45ii1CMEgW4BUYsn7JDCmXF50x4p5DpJF4nBw4PcsMeta } from "/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@3/pages/search/index.vue?macro=true";
import { default as productsN4XCbC1jvMYjbwJOva61ZcB7DXi2XQvXvectgE_458paAMeta } from "/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@3/pages/search/products.vue?macro=true";
import { default as documents9kfgkjk1_459DvqDKTtCjwWXgZQuG2PDkasS3P9bcdyxoMeta } from "/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@3/pages/search/documents.vue?macro=true";
import { default as searchSwwWyxGkGLHwBcVKPTGiNAVeiT8WqXRxK9ZbSDnchucMeta } from "/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@3/pages/search.vue?macro=true";
import { default as _91slug_930ZEJEZyZgbnyiomsgoKR6FL54rzBzOXQXalKdxRqzZkMeta } from "/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@3/pages/news/[slug].vue?macro=true";
import { default as index5w8YBOKEJmhTLBgjfxD8vPO4Dt3KPdylpy7TM7j8dwwMeta } from "/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@3/pages/catalog/index.vue?macro=true";
import { default as _91slug_938S_45GkHxts2qs4dOXUlO3z7DhHAkad2kwnILOS2DSQQEMeta } from "/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@3/pages/catalog/[slug].vue?macro=true";
import { default as _91slug_93f4KjfL8DadKqyEqtwA_45lJMHgp5RFvQ90zSw18myLjF8Meta } from "/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@3/pages/product/[slug].vue?macro=true";
import { default as index9MSvp_v_GalZXgHbKxXy7L65BMepUfhvYDEAuarSIxQMeta } from "/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@3/pages/documents/[slug]/index.vue?macro=true";
export default [
  {
    name: "index___en",
    path: "/",
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@3/pages/index.vue")
  },
  {
    name: "slug___en",
    path: "/:slug()",
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@3/pages/[slug].vue")
  },
  {
    name: searchSwwWyxGkGLHwBcVKPTGiNAVeiT8WqXRxK9ZbSDnchucMeta?.name,
    path: "/search",
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@3/pages/search.vue"),
    children: [
  {
    name: "search___en",
    path: "",
    meta: indexVOF_45ii1CMEgW4BUYsn7JDCmXF50x4p5DpJF4nBw4PcsMeta || {},
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@3/pages/search/index.vue")
  },
  {
    name: "search-products___en",
    path: "products",
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@3/pages/search/products.vue")
  },
  {
    name: "search-documents___en",
    path: "documents",
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@3/pages/search/documents.vue")
  }
]
  },
  {
    name: "news-slug___en",
    path: "/news/:slug()",
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@3/pages/news/[slug].vue")
  },
  {
    name: "catalog___en",
    path: "/catalog",
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@3/pages/catalog/index.vue")
  },
  {
    name: "catalog-slug___en",
    path: "/catalog/:slug()",
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@3/pages/catalog/[slug].vue")
  },
  {
    name: "product-slug___en",
    path: "/product/:slug()",
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@3/pages/product/[slug].vue")
  },
  {
    name: "documents-slug___en",
    path: "/documents/:slug()",
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@3/pages/documents/[slug]/index.vue")
  }
]